import { render, staticRenderFns } from "./addSubscribe.vue?vue&type=template&id=56507f88&scoped=true"
import script from "./addSubscribe.vue?vue&type=script&lang=js"
export * from "./addSubscribe.vue?vue&type=script&lang=js"
import style0 from "./addSubscribe.vue?vue&type=style&index=0&id=56507f88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56507f88",
  null
  
)

export default component.exports